<template>
  <v-app>
    <component v-if="errorComponent" :is="errorComponent"></component>
    <template v-else>
      <app-header v-if="hasHeader"></app-header>
      <router-view></router-view>
    </template>
    <app-snackbar></app-snackbar>
    <update-system-modal></update-system-modal>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import AppHeader from '@/components/AppHeader'
import AppSnackbar from '@/components/AppSnackbar'
import UpdateSystemModal from '@/components/UpdateSystemModal'
import Error404 from '@/views/Errors/404.vue'
import Error500 from '@/views/Errors/500.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppSnackbar,
    UpdateSystemModal,
    Error404,
    Error500
  },
  computed: {
    ...mapGetters(['errorPage']),
    errorComponent () {
      return (this.errorPage) ? 'Error' + this.errorPage : false
    },
    hasHeader () {
      return !(this.$route.meta && this.$route.meta.noHeader)
    }
  }
}
</script>
